import { IDictionary, isNullOrUndefined } from '@bimser/core';
import { getMLText } from '../../helper';

export class MultiLanguageInputText {
	private enableMultiLanguageText: boolean;
	private userCulture: string;
	private defaultCulture: string;
	private data: IDictionary<string>;

	[key: string]: any; // Index signature

	onChange: (culture: string, text: string) => void;

	previousChangeArgs: string; // Değişen değerin store a yazılmadan önce this.data güncellenmediği için aynı isteğin tekrar tekrar gönderilmesi engellendi.

	private onTriggerChange(culture: string, text: string) {
		if (!this.previousChangeArgs || this.previousChangeArgs !== `${culture}[${text}]`) {
			if (this.data[culture] !== text) {
				this.onChange(culture, text);
				this.previousChangeArgs = `${culture}[${text}]`;
			}
		}
	}

	constructor(
		onChange: (culture: string, text: string) => void,
		data: IDictionary<string>,
		enableMultiLanguageText?: boolean,
		userCulture?: string,
		defaultCulture?: string
	) {
		this.onChange = onChange;
		this.data = data || {};
		this.enableMultiLanguageText = enableMultiLanguageText;
		this.userCulture = userCulture;
		this.defaultCulture = defaultCulture;

		Object.keys(this.data).forEach(culture => {
			(this as any)[culture] = this.data[culture];
		});

		return proxyCreator(this, this.setter.bind(this));
	}

	private setter(target: MultiLanguageInputText, value: string, key: string) {
		(target as any)[key] = value;
		Object.keys(this.data).forEach(culture => {
			this.onTriggerChange(culture, this.data[culture]);
		});
	}

	getText(culture?: string, dontForce?: boolean) {
		return getMLText({
			culture,
			dontForce,
			enableMultiLanguageText: this.enableMultiLanguageText,
			data: this.data,
			userCulture: this.userCulture,
			defaultCulture: this.defaultCulture
		});
	}

	setText(text: string, culture?: string) {
		let newData = { ...this.data };

		if (this.enableMultiLanguageText) {
			newData = { ...this.data, [culture || this.userCulture]: text };
			culture = culture || this.userCulture;
		} else {
			newData = { ...this.data, ['system']: text };
			culture = 'system';
		}

		this.onTriggerChange(culture, text);
	}

	removeText(culture?: string) {
		const newData = { ...this.data };

		if (this.enableMultiLanguageText) {
			delete newData[culture || this.userCulture];
			culture = culture || this.userCulture;
		} else {
			delete newData['system'];
			culture = 'system';
		}

		this.onTriggerChange(culture, undefined);
	}

	removeAll() {
		Object.keys(this.data).forEach(culture => {
			this.onTriggerChange(culture, undefined);
		});
	}

	setEnableMultiLanguageText(enableMultiLanguageText: boolean) {
		this.enableMultiLanguageText = enableMultiLanguageText;
	}

	getData() {
		return this.data;
	}

	setData(data: IDictionary<string>) {
		this.data = data;

		Object.keys(this.data).forEach(culture => {
			this[culture] = this.data[culture];
		});

		this.previousChangeArgs = '';
	}
}

function proxyCreator<MultiLanguageInputText>(
	obj: MultiLanguageInputText,
	setter: (target: MultiLanguageInputText, value: any, name: string) => void
): MultiLanguageInputText {
	const handler: ProxyHandler<any> = {
		get(target: any, key: string) {
			return target[key];
		},
		set(target, key: string, value) {
			setter(target, value, key);
			return true;
		}
	};

	return new Proxy(obj, handler);
}
